import { useState, useContext, useEffect } from "react";
import { fetchContactsById } from "apps/volunteers/vms-queries";
import Decorator from "clientDecorator";
import TaskRowDetailsContactCard from "../task-row/task-row-details-contact-card";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import SelectedTaskInteractions from "./selected-task-interactions";
import SelectedTaskPinnedComments from "./selected-task-pinned-comments";
import SelectedTaskGiftHistory from "./selected-task-gift-history";
import { Icon } from "@evertrue/et-components";
import SelectedTaskCompletion from "./selected-task-completion";
import Household from "./household";

const SelectedTaskDetails = () => {
  const [contact, setContact] = useState();
  const { selectedTask } = useContext(JourneysContext);

  useEffect(() => {
    const getAndSetContactForTask = async (id) => {
      const { items } = await fetchContactsById({ contactIds: [id] });
      const [fullContact] = items;
      const decoratedContact = Decorator.Contacts.parse(fullContact);
      setContact(decoratedContact);
    };
    if (!selectedTask) return;
    getAndSetContactForTask(selectedTask.contact && selectedTask.contact.id);
  }, [selectedTask]);

  if (!selectedTask || !contact) return null;

  const { linkedin: { public_profile_url: { value: linkedInUrl = "" } = {} } = {} } = contact;
  const { completed_at } = selectedTask;

  const { household_members = [] } = selectedTask.contact || {};

  return (
    <div className="journey-selected-task-details--sticky">
      <div style={{ display: "flex" }}>
        <TaskRowDetailsContactCard contact={selectedTask.contact} avatarSize={60} padding={16} />
        {household_members.length > 0 && <Household contact={selectedTask.contact} />}
      </div>
      {linkedInUrl && (
        <a href={linkedInUrl} target="_blank" rel="noreferrer" className="linkedin-link">
          <Icon icon="linkedin-2020" className="linkedin-icon" />
          LinkedIn
        </a>
      )}
      {!!completed_at && <SelectedTaskCompletion />}
      <SelectedTaskGiftHistory contact={contact} />
      <SelectedTaskPinnedComments contact={contact} />
      <SelectedTaskInteractions contact={contact} />
    </div>
  );
};

export default SelectedTaskDetails;
